// extracted by mini-css-extract-plugin
export default {"tableWrapper":"RightsPage_tableWrapper__0DWwH","oddRow":"RightsPage_oddRow__lF+r0"};